import { Component } from '@angular/core';
import { LanguageService } from '../../../../core/services/language.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-option-register-renew',
  imports: [],
  templateUrl: './option-register-renew.component.html',
  styleUrl: './option-register-renew.component.css'
})
export class OptionRegisterRenewComponent {
  currentLang: "TH" | "EN" = "TH";

  constructor(
    private langService: LanguageService,
    private router: Router
  ) {
    this.langService.currentLang$.subscribe(lang => {
      this.currentLang = lang;
      console.log('Current language:', this.currentLang);
    });
  }


  /* ----------------------------------- Functions ----------------------------------- */
  goback() {
    this.router.navigate(['/home']);
  }

  goToRegister() {
    this.router.navigate(['/service-providers']);
  }

  goToRenew() {
    this.router.navigate(['/my-member-card']);
  }
}
